import React from 'react';
import _ from 'lodash';
import SchemaForm from 'app/components/general/SchemaForm';
import SectionGroup from 'app/components/general/SectionGroup';
import HeaderThin from 'app/components/layout/HeaderThin';
import history from 'app/routes/history';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MatchesTable from 'app/components/matches/MatchesTable';

import * as teamPaymentRequestActions from 'app/ducks/teamPaymentRequests/actions';
import * as seasonActions from 'app/ducks/seasons/actions';
import * as addressActions from 'app/ducks/addresses/actions';
import * as paymentEventActions from 'app/ducks/paymentEvents/actions';
import * as teamPaymentRequestSelectors from 'app/ducks/teamPaymentRequests/selectors';
import * as seasonSelectors from 'app/ducks/seasons/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as paymentEventSelectors from 'app/ducks/paymentEvents/selectors';

const selector = (state) => ({
  teams: teamsSelectors.getTeams(state),
  groups: groupsSelectors.getGroups(state),
  teamPaymentRequests: teamPaymentRequestSelectors.getTeamPaymentRequests(state),
  paymentEvents: paymentEventSelectors.getPaymentEvents(state),
  seasons: seasonSelectors.getSeasons(state),
  errors: { ...state.teamPaymentRequests.backendErrors },
});

const actionCreators = _.merge(teamPaymentRequestActions, addressActions, seasonActions, paymentEventActions);

interface IEditTeamPaymentRequestProps {
  appReady: boolean;
  actions: any;
  teams: any;
  groups: any;
  teamPaymentRequests: any;
  paymentEvents: any;
  seasons: any;
  errors: any;
  backendErrors: any;
  match: any;
  teamPaymentRequestId: string;
  afterSubmit: Function;
}

export interface IEditTeamPaymentRequestState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  reset: boolean;
  errors: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class EditTeamPaymentRequest extends React.Component<
IEditTeamPaymentRequestProps,
IEditTeamPaymentRequestState
> {
  static defaultProps: IEditTeamPaymentRequestProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    groups: undefined,
    teamPaymentRequests: undefined,
    paymentEvents: undefined,
    seasons: undefined,
    backendErrors: undefined,
    errors: undefined,
    teamPaymentRequestId: undefined,
    afterSubmit: undefined,
  };

  state: IEditTeamPaymentRequestState = {
    originalFormData: {},
    formData: {},
    changed: false,
    saved: false,
    reset: false,
    errors: {},
  };

  componentDidMount() {
    this.props.actions.getAllPaymentEventsForAllTeams();
  }

  // static getDerivedStateFromProps(nextProps, prevState): any {
  //   if (!prevState.reset && !prevState.changed) {

  //     return {
  //       ...prevState,
  //       formData,
  //       originalFormData: formData,
  //       errors: nextProps.teamPaymentRequests.errors,
  //     };
  //   }
  //   // if (nextProps.hasSaved) {
  //   //   return {
  //   //     originalFormData: {},
  //   //     formData: {},
  //   //     changed: false,
  //   //     saved: false,
  //   //     errors: {},
  //   //   };
  //   // }
  //   return null;
  // }

  isValid = (): boolean => _.isEmpty(this.state.errors) && this.state.changed;

  handleSelectMatch = (id, row): void => {
    const payload = {
      id: this.props.teamPaymentRequests.currentTeamPaymentRequestId,
      matchPayment: {
        id: row.matchPaymentId,
      },
      group: {
        id: row.groupId,
      },
    };
    this.props.actions.updateTeamPaymentRequest(payload);
    if (this.props.afterSubmit !== undefined) {
      this.props.afterSubmit();
    }
  };

  groupIds = () => {
    const groupIds = [];

    _.each(this.props.teams.teamsById, (t) => {
      _.each(t.groups, (g) => {
        if (!_.isEmpty(g?.id)) {
          groupIds.push({ teamId: t.id, groupId: g?.id });
        }
      });
    });

    return _.uniqBy(groupIds, (u) => u.groupId);
  }

  render(): React.ReactNode {
    return (
      <div className="margin-bottom">
        <MatchesTable
          {...this.props.paymentEvents}
          hideAmount
          hideActions
          aggressiveLoader
          headerTitle="Select a Match"
          groupIds={this.groupIds()}
          groupsById={this.props.groups.groupsById}
          appReady={this.props.appReady}
          selectTeam={this.props.actions.selectTeam}
          actions={this.props.actions}
          handleClick={(id, row) => {
            this.handleSelectMatch(id, row);
          }}
        />
      </div>
    );
  }
}
